/**
 * Tells the user their account was signed in elsewhere and this device is on
 * its way out. Mirrored from `bimgo-ai-web`'s `SignOutWarningBanner` (#75).
 *
 * No countdown on purpose — the deadline can move (a network failure defers the
 * confirmation, a false alarm cancels it outright), and a ticking clock that
 * then does not fire reads as a bug. The banner says "shortly" and means it.
 *
 * Floats top-centre, below the window titlebar, rather than spanning the top
 * or sitting in a corner: the caption buttons, the sidebar and the chat
 * header's controls all stay usable for the whole grace window, which is the
 * point of having one. Amber, matching the notice the login page shows
 * once the sign-out has actually happened (`pages/Login.tsx`), so the two read
 * as one message delivered in two parts.
 */
import { useLocale } from "../i18n/LocaleProvider";

export function SignOutWarningBanner() {
  const { t } = useLocale();
  return (
    <div className="signout-warning" role="status">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
      </svg>
      <p>{t("auth.signingOutSoon")}</p>
    </div>
  );
}
